module.exports = __webpack_public_path__ + "img/tb-2.dc1160ea.jpg";